import { render, staticRenderFns } from "./CommonCat.vue?vue&type=template&id=369bbc19&scoped=true"
import script from "./CommonCat.vue?vue&type=script&lang=js"
export * from "./CommonCat.vue?vue&type=script&lang=js"
import style0 from "./CommonCat.vue?vue&type=style&index=0&id=369bbc19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369bbc19",
  null
  
)

export default component.exports